import { render, staticRenderFns } from "./tabControl.vue?vue&type=template&id=15ba9f84&scoped=true&"
import script from "./tabControl.vue?vue&type=script&lang=js&"
export * from "./tabControl.vue?vue&type=script&lang=js&"
import style0 from "./tabControl.vue?vue&type=style&index=0&id=15ba9f84&prod&lang=css&"
import style1 from "./tabControl.vue?vue&type=style&index=1&id=15ba9f84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ba9f84",
  null
  
)

export default component.exports